import type {ReactNode} from 'react';
import React from 'react';
import LevelBadge from 'assets/images/adaptive/LevelBadge';

import {PROFICIENCY_SEGMENTS_BY_METHOD} from 'client/Reports/lib/constants/proficiencySegments';

export type Segment = {
  label: string;
  value: number;
  percentage: number;
  color: string;
};

const DEFAULT_INDEX = 4;

export const SORT_KEY_TO_INDEX: Record<string, number> = Object.fromEntries(
  Object.values(PROFICIENCY_SEGMENTS_BY_METHOD).flatMap(({segments}) =>
    segments.map((segment) => [segment.sortKey, segment.index])
  )
);

export const getSelectedIndex = (sortBy: string | null | undefined) => {
  // default shows Advanced (index 4)
  if (!sortBy) {
    return DEFAULT_INDEX;
  }
  return SORT_KEY_TO_INDEX[sortBy] ?? DEFAULT_INDEX;
};

export const getPercentageLabel = (
  segments: Segment[],
  selectedIndex: number,
  allNotStarted: boolean
) => {
  if (allNotStarted) {
    return 'Not started: 100%';
  }
  const seg = segments[selectedIndex];
  return `${seg.label}: ${seg.percentage}%`;
};

export const getIconForIndex = (index: number): ReactNode | null => {
  switch (index) {
    case 2:
      return <LevelBadge width={16} height={16} fidelity='low' levelNum={1} />;
    case 3:
      return <LevelBadge width={16} height={16} fidelity='low' levelNum={2} />;
    case 4:
      return <LevelBadge width={16} height={16} fidelity='low' levelNum={3} />;
    default:
      return null; // Not started / Unranked
  }
};
